import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import ls from 'local-storage';
import { USER_ROUTES } from 'routes/routes';

import chevron from '../../assets/chevron-down.svg';
import account_icon from '../../assets/user_account.svg';

export const AccountMenu = () => {
  const navigate = useNavigate();

  return (
    <Menu as='div' className="relative ml-3">
      <Menu.Button className='flex items-center space-x-2 text-white text-lg leading-5 font-bold font-["Nunito_Sans"]'>
        <img src={account_icon} alt='Profile' className='mr-2' />
        <span>My profile</span>
        <img src={chevron} alt='Profile' />
      </Menu.Button>
      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Menu.Items
          className="bg-[rgb(16,13,11)] border border-[rgb(29,29,29)] w-[132px] px-4 box-border flex flex-col absolute right-0 z-10 mt-5 origin-top-right shadow-sm rounded-xl ring-1 ring-black ring-opacity-5 focus:outline-none"
          anchor="bottom"
        >
          <Menu.Item onClick={() => navigate(USER_ROUTES.PROFILE())}>
            <span className="font-['Nunito_Sans'] text-white py-4 text-base leading-[18px] block hover:text-gray-200 cursor-pointer border-b border-b-[rgb(29,29,29)]">
              My profile
            </span>
          </Menu.Item>
          <Menu.Item onClick={() => navigate(USER_ROUTES.HISTORY())}>
            <span className="font-['Nunito_Sans'] text-white py-4 text-base leading-[18px] block hover:text-gray-200 cursor-pointer border-b border-b-[rgb(29,29,29)]">
              History
            </span>
          </Menu.Item>
          <Menu.Item onClick={() => {
            ls.remove('token');
            navigate('/');
            window.location.reload();
          }}>
            <span className="font-['Nunito_Sans'] text-white py-4 text-base leading-[18px] block hover:text-gray-200 cursor-pointer">
              Log out
            </span>
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};